import { render, staticRenderFns } from "./SearchDemo.vue?vue&type=template&id=0dd313e4&"
import script from "./SearchDemo.vue?vue&type=script&lang=js&"
export * from "./SearchDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports